
    <!--
 * 竖版-首页
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_K1XQ135"  :class="[`normal`,`u_c_K1XQ135`]" ><a id="u_c_EGZF136" href="javascript:;" :class="[`normal btn-light`,`u_c_EGZF136`]" @click="u_c_EGZF136_event_8QY427($event)">{{`${ langData.infoBtn }`}}</a><div id="u_c_INJH138"  :class="[`normal`,`u_c_INJH138`]" ></div><div id="u_c_5DOV139"  v-html="compData.title" :class="[`normal`,`u_c_5DOV139`]" ></div><div id="u_c_G5KT140"  :class="[`normal`,`u_c_G5KT140`]" ><div id="u_c_7OVW141"  v-html="compData.eventTime" :class="[`normal`,`u_c_7OVW141`]" ></div></div><div id="u_c_8QKA142"  :class="[`normal`,`u_c_8QKA142`]" ><div id="u_c_IJFI143"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_IJFI143`]" ><div id="u_c_5076144"  :class="[`normal txt`,`u_c_5076144`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_9N0F146" href="javascript:;" :class="[`normal txt btn`,`u_c_9N0F146`]" @click="u_c_9N0F146_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_IC6I148"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_IC6I148`]" ><div id="u_c_67TS149"  v-show="pageData.isBind" :class="[`normal txt btn`,`u_c_67TS149`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_31I8151"  :class="[`normal`,`u_c_31I8151`]" ><a id="u_c_8RVR152" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn `,`u_c_8RVR152`]" @click="u_c_8RVR152_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_IJTU154" href="javascript:;" v-show="pageData.isBind && pageData.canReBind" :class="[`normal txt btn `,`u_c_IJTU154`]" @click="u_c_IJTU154_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_HF2S156" href="javascript:;" :class="[`normal txt btn `,`u_c_HF2S156`]" @click="u_c_HF2S156_event_4DJR33($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_B3AX158" href="javascript:;" :class="[`normal txt btn`,`u_c_B3AX158`]" @click="u_c_B3AX158_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2023年2月28日 ～2023年3月3日23:59`,"title":`2周年庆典`},"zh-CN":{"eventTime":`活动时间：2024年7月23日 0:00-2024年8月5日 23:59（UTC）`,"title":`4周年庆典`},"zh-TW":{"eventTime":`活動時間：2024年7月23日 0：00-2024年8月5日 23：59（UTC）`,"title":`4週年慶典`},"en-US":{"eventTime":`Event Duration: July 23, 2024, 00:00 - August 5, 2024, 23:59 (UTC)`,"title":`4nniversary Celebration`},"ja-JP":{"eventTime":`イベント期間：2024年7月23日0:00~2024年8月5日 23:59（UTC）`,"title":`4周年記念`},"ko-KR":{"eventTime":`이벤트 기간: 2024년 7월 23일 00:00 ~ 2024년 8월 5일 23:59 (UTC)`,"title":`4주년 축제`},"th-TH":{"eventTime":`เวลากิจกรรม: วันที่ 23 กรกฎาคม 2024 เวลา 0:00 น. - วันที่ 5 สิงหาคม 2024 เวลา 23:59 น.(UTC)`,"title":`งานฉลองครบรอบ 4 ปี`},"vi-VN":{"eventTime":``,"title":``},"de-DE":{"eventTime":`Eventdauer: 23. Juli 2024, 00:00 Uhr - 5. August 2024, 23:59 Uhr (UTC)`,"title":`Jubiläumsfeier`},"fr-FR":{"eventTime":`Durée de l'Événement : 23 Juillet 2024, 00h00 - 5 Août 2024, 23h59 (UTC)`,"title":`Célébration du 4ème Anniversaire`},"ru-RU":{"eventTime":`Время события: 23 июля 2024, 00:00 – 5 августа 2024, 23:59 (UTC)`,"title":`Празднование 4-го юбилея`},"es-ES":{"eventTime":`Duración del evento: 23 de julio, 2024, 00:00 - 5 de agosto, 2024, 23:59 (UTC)`,"title":`Celebración de 4niversario`},"pt-PT":{"eventTime":`Duração do evento: 23 de julho de 2024, 00h00 - 5 de agosto de 2024, 23h59 (UTC)`,"title":`Comemoração de 4niversário`},"it-IT":{"eventTime":`Durata Evento: 23 luglio 2024, 00:00 - 5 agosto 2024, 23:59 (UTC)
`,"title":`Celebrazione 4nniversario
`},"tr-TR":{"eventTime":`Duração do evento: 23 de julho de 2024, 00h00 - 5 de agosto de 2024, 23h59 (UTC)`,"title":`Comemoração de 4niversário`},"pl-PL":{"eventTime":`Czas trwania wydarzenia: 23 lipca 2024, 00:00 - 5 sierpnia 2024, 23:59 (UTC)
`,"title":`Świętowanie 4. rocznicy
`},"id-ID":{"eventTime":`Waktu Event: 23/7/2024 00:00 - 5/8/2024 23:59 (UTC)
`,"title":`4th Anniversary Celebration
`},"ar-SA":{"eventTime":`وقت الحدث: 23 يوليو 2024 الساعة 0:00 - 5 أغسطس 2024 الساعة 23:59 (التوقيت العالمي المنسق)
`,"title":`مهرجان الذكرى السنوية الرابعة
`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})

const curPlatform = pagePlatform;

const canClickChange = ref(true);
;
      // 活动规则的click事件
      const u_c_EGZF136_event_8QY427= async (e)=>{
        try {pageData.infoPopupState = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_9N0F146_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_8RVR152_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_IJTU154_event_Z75334= async (e)=>{
        try {if(!canClickChange.value)return;

canClickChange.value = false;

const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=resetUserBind`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=resetUserBind`,
  omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=resetUserBind`,
}
let res = await request.getJSON(link[curPlatform])
canClickChange.value = true;

if(res.result!=1){
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName ="";
pageData.serverName = "";
} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_HF2S156_event_4DJR33= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_B3AX158_event_Q72S64= async (e)=>{
        try {let link = {
  gm99: `https://passport.gm99.com/login/logout2`,
  global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
  omnion: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
}
let res = await request.getJSON(link[curPlatform])
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.default{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.default{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16715369121381.png);
background-size:contain;

}
}.default{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.default{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.default{
.u_c_7OVW141.normal{
position:relative;

}
}.default{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.default{
.u_c_IJFI143.normal{
position:relative;

}
}.default{
.u_c_5076144.normal{
position:relative;

}
}.default{
.u_c_9N0F146.normal{
position:relative;

}
}.default{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_8RVR152.normal{
position:relative;

}
}.default{
.u_c_IJTU154.normal{
position:relative;

}
}.default{
.u_c_HF2S156.normal{
position:relative;

}
}.default{
.u_c_B3AX158.normal{
position:relative;

}
}.zh-CN{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.zh-CN{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.zh-CN{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-size:contain;

}
}.zh-CN{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.zh-CN{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-CN{
.u_c_7OVW141.normal{
position:relative;

}
}.zh-CN{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.zh-CN{
.u_c_IJFI143.normal{
position:relative;

}
}.zh-CN{
.u_c_5076144.normal{
position:relative;

}
}.zh-CN{
.u_c_9N0F146.normal{
position:relative;

}
}.zh-CN{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-CN{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_8RVR152.normal{
position:relative;

}
}.zh-CN{
.u_c_IJTU154.normal{
position:relative;

}
}.zh-CN{
.u_c_HF2S156.normal{
position:relative;

}
}.zh-CN{
.u_c_B3AX158.normal{
position:relative;

}
}.zh-TW{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.zh-TW{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.zh-TW{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170963649343264484.png);
background-size:contain;

}
}.zh-TW{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.zh-TW{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-TW{
.u_c_7OVW141.normal{
position:relative;

}
}.zh-TW{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.zh-TW{
.u_c_IJFI143.normal{
position:relative;

}
}.zh-TW{
.u_c_5076144.normal{
position:relative;

}
}.zh-TW{
.u_c_9N0F146.normal{
position:relative;

}
}.zh-TW{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-TW{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_8RVR152.normal{
position:relative;

}
}.zh-TW{
.u_c_IJTU154.normal{
position:relative;

}
}.zh-TW{
.u_c_HF2S156.normal{
position:relative;

}
}.zh-TW{
.u_c_B3AX158.normal{
position:relative;

}
}.en-US{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.en-US{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.en-US{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.en-US{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.en-US{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.en-US{
.u_c_7OVW141.normal{
position:relative;

}
}.en-US{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.en-US{
.u_c_IJFI143.normal{
position:relative;

}
}.en-US{
.u_c_5076144.normal{
position:relative;

}
}.en-US{
.u_c_9N0F146.normal{
position:relative;

}
}.en-US{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.en-US{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_8RVR152.normal{
position:relative;

}
}.en-US{
.u_c_IJTU154.normal{
position:relative;

}
}.en-US{
.u_c_HF2S156.normal{
position:relative;

}
}.en-US{
.u_c_B3AX158.normal{
position:relative;

}
}.ja-JP{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ja-JP{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.ja-JP{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716047187983243.png);
background-size:contain;

}
}.ja-JP{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ja-JP{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ja-JP{
.u_c_7OVW141.normal{
position:relative;

}
}.ja-JP{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.ja-JP{
.u_c_IJFI143.normal{
position:relative;

}
}.ja-JP{
.u_c_5076144.normal{
position:relative;

}
}.ja-JP{
.u_c_9N0F146.normal{
position:relative;

}
}.ja-JP{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ja-JP{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_8RVR152.normal{
position:relative;

}
}.ja-JP{
.u_c_IJTU154.normal{
position:relative;

}
}.ja-JP{
.u_c_HF2S156.normal{
position:relative;

}
}.ja-JP{
.u_c_B3AX158.normal{
position:relative;

}
}.ko-KR{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ko-KR{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.ko-KR{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716047120529216.png);
background-size:contain;

}
}.ko-KR{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ko-KR{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ko-KR{
.u_c_7OVW141.normal{
position:relative;

}
}.ko-KR{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.ko-KR{
.u_c_IJFI143.normal{
position:relative;

}
}.ko-KR{
.u_c_5076144.normal{
position:relative;

}
}.ko-KR{
.u_c_9N0F146.normal{
position:relative;

}
}.ko-KR{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ko-KR{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_8RVR152.normal{
position:relative;

}
}.ko-KR{
.u_c_IJTU154.normal{
position:relative;

}
}.ko-KR{
.u_c_HF2S156.normal{
position:relative;

}
}.ko-KR{
.u_c_B3AX158.normal{
position:relative;

}
}.th-TH{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.th-TH{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.th-TH{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716047123653072.png);
background-size:contain;

}
}.th-TH{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.th-TH{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.th-TH{
.u_c_7OVW141.normal{
position:relative;

}
}.th-TH{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.th-TH{
.u_c_IJFI143.normal{
position:relative;

}
}.th-TH{
.u_c_5076144.normal{
position:relative;

}
}.th-TH{
.u_c_9N0F146.normal{
position:relative;

}
}.th-TH{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.th-TH{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_8RVR152.normal{
position:relative;

}
}.th-TH{
.u_c_IJTU154.normal{
position:relative;

}
}.th-TH{
.u_c_HF2S156.normal{
position:relative;

}
}.th-TH{
.u_c_B3AX158.normal{
position:relative;

}
}.vi-VN{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.vi-VN{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.vi-VN{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716047123653072.png);
background-size:contain;

}
}.vi-VN{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.vi-VN{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.vi-VN{
.u_c_7OVW141.normal{
position:relative;

}
}.vi-VN{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.vi-VN{
.u_c_IJFI143.normal{
position:relative;

}
}.vi-VN{
.u_c_5076144.normal{
position:relative;

}
}.vi-VN{
.u_c_9N0F146.normal{
position:relative;

}
}.vi-VN{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.vi-VN{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_8RVR152.normal{
position:relative;

}
}.vi-VN{
.u_c_IJTU154.normal{
position:relative;

}
}.vi-VN{
.u_c_HF2S156.normal{
position:relative;

}
}.vi-VN{
.u_c_B3AX158.normal{
position:relative;

}
}.de-DE{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.de-DE{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.de-DE{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716047123653072.png);
background-size:contain;

}
}.de-DE{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.de-DE{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.de-DE{
.u_c_7OVW141.normal{
position:relative;

}
}.de-DE{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.de-DE{
.u_c_IJFI143.normal{
position:relative;

}
}.de-DE{
.u_c_5076144.normal{
position:relative;

}
}.de-DE{
.u_c_9N0F146.normal{
position:relative;

}
}.de-DE{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.de-DE{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_8RVR152.normal{
position:relative;

}
}.de-DE{
.u_c_IJTU154.normal{
position:relative;

}
}.de-DE{
.u_c_HF2S156.normal{
position:relative;

}
}.de-DE{
.u_c_B3AX158.normal{
position:relative;

}
}.fr-FR{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.fr-FR{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.fr-FR{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264681-83.png);
background-size:contain;

}
}.fr-FR{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.fr-FR{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.fr-FR{
.u_c_7OVW141.normal{
position:relative;

}
}.fr-FR{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.fr-FR{
.u_c_IJFI143.normal{
position:relative;

}
}.fr-FR{
.u_c_5076144.normal{
position:relative;

}
}.fr-FR{
.u_c_9N0F146.normal{
position:relative;

}
}.fr-FR{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.fr-FR{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_8RVR152.normal{
position:relative;

}
}.fr-FR{
.u_c_IJTU154.normal{
position:relative;

}
}.fr-FR{
.u_c_HF2S156.normal{
position:relative;

}
}.fr-FR{
.u_c_B3AX158.normal{
position:relative;

}
}.ru-RU{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ru-RU{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.ru-RU{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264681-83.png);
background-size:contain;

}
}.ru-RU{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ru-RU{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ru-RU{
.u_c_7OVW141.normal{
position:relative;

}
}.ru-RU{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.ru-RU{
.u_c_IJFI143.normal{
position:relative;

}
}.ru-RU{
.u_c_5076144.normal{
position:relative;

}
}.ru-RU{
.u_c_9N0F146.normal{
position:relative;

}
}.ru-RU{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ru-RU{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_8RVR152.normal{
position:relative;

}
}.ru-RU{
.u_c_IJTU154.normal{
position:relative;

}
}.ru-RU{
.u_c_HF2S156.normal{
position:relative;

}
}.ru-RU{
.u_c_B3AX158.normal{
position:relative;

}
}.es-ES{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.es-ES{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.es-ES{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264681-83.png);
background-size:contain;

}
}.es-ES{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.es-ES{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.es-ES{
.u_c_7OVW141.normal{
position:relative;

}
}.es-ES{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.es-ES{
.u_c_IJFI143.normal{
position:relative;

}
}.es-ES{
.u_c_5076144.normal{
position:relative;

}
}.es-ES{
.u_c_9N0F146.normal{
position:relative;

}
}.es-ES{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.es-ES{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_8RVR152.normal{
position:relative;

}
}.es-ES{
.u_c_IJTU154.normal{
position:relative;

}
}.es-ES{
.u_c_HF2S156.normal{
position:relative;

}
}.es-ES{
.u_c_B3AX158.normal{
position:relative;

}
}.pt-PT{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.pt-PT{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.pt-PT{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.pt-PT{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.pt-PT{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pt-PT{
.u_c_7OVW141.normal{
position:relative;

}
}.pt-PT{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.pt-PT{
.u_c_IJFI143.normal{
position:relative;

}
}.pt-PT{
.u_c_5076144.normal{
position:relative;

}
}.pt-PT{
.u_c_9N0F146.normal{
position:relative;

}
}.pt-PT{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pt-PT{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_8RVR152.normal{
position:relative;

}
}.pt-PT{
.u_c_IJTU154.normal{
position:relative;

}
}.pt-PT{
.u_c_HF2S156.normal{
position:relative;

}
}.pt-PT{
.u_c_B3AX158.normal{
position:relative;

}
}.it-IT{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.it-IT{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.it-IT{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.it-IT{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.it-IT{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.it-IT{
.u_c_7OVW141.normal{
position:relative;

}
}.it-IT{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.it-IT{
.u_c_IJFI143.normal{
position:relative;

}
}.it-IT{
.u_c_5076144.normal{
position:relative;

}
}.it-IT{
.u_c_9N0F146.normal{
position:relative;

}
}.it-IT{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.it-IT{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_8RVR152.normal{
position:relative;

}
}.it-IT{
.u_c_IJTU154.normal{
position:relative;

}
}.it-IT{
.u_c_HF2S156.normal{
position:relative;

}
}.it-IT{
.u_c_B3AX158.normal{
position:relative;

}
}.tr-TR{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.tr-TR{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.tr-TR{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.tr-TR{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.tr-TR{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.tr-TR{
.u_c_7OVW141.normal{
position:relative;

}
}.tr-TR{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.tr-TR{
.u_c_IJFI143.normal{
position:relative;

}
}.tr-TR{
.u_c_5076144.normal{
position:relative;

}
}.tr-TR{
.u_c_9N0F146.normal{
position:relative;

}
}.tr-TR{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.tr-TR{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_8RVR152.normal{
position:relative;

}
}.tr-TR{
.u_c_IJTU154.normal{
position:relative;

}
}.tr-TR{
.u_c_HF2S156.normal{
position:relative;

}
}.tr-TR{
.u_c_B3AX158.normal{
position:relative;

}
}.pl-PL{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.pl-PL{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.pl-PL{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.pl-PL{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.pl-PL{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pl-PL{
.u_c_7OVW141.normal{
position:relative;

}
}.pl-PL{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.pl-PL{
.u_c_IJFI143.normal{
position:relative;

}
}.pl-PL{
.u_c_5076144.normal{
position:relative;

}
}.pl-PL{
.u_c_9N0F146.normal{
position:relative;

}
}.pl-PL{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pl-PL{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_8RVR152.normal{
position:relative;

}
}.pl-PL{
.u_c_IJTU154.normal{
position:relative;

}
}.pl-PL{
.u_c_HF2S156.normal{
position:relative;

}
}.pl-PL{
.u_c_B3AX158.normal{
position:relative;

}
}.id-ID{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.id-ID{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.id-ID{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.id-ID{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.id-ID{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.id-ID{
.u_c_7OVW141.normal{
position:relative;

}
}.id-ID{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.id-ID{
.u_c_IJFI143.normal{
position:relative;

}
}.id-ID{
.u_c_5076144.normal{
position:relative;

}
}.id-ID{
.u_c_9N0F146.normal{
position:relative;

}
}.id-ID{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.id-ID{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_8RVR152.normal{
position:relative;

}
}.id-ID{
.u_c_IJTU154.normal{
position:relative;

}
}.id-ID{
.u_c_HF2S156.normal{
position:relative;

}
}.id-ID{
.u_c_B3AX158.normal{
position:relative;

}
}.ar-SA{
.u_c_K1XQ135.normal{
position:relative;
width:10.00rem;
height:11.08rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721370161897-14.jpeg);
overflow:hidden;
margin:auto;
font-size:0;

}
}.ar-SA{
.u_c_EGZF136.normal{
position:absolute;
width:2.72rem;
height:0.93rem;
top:0.40rem;
right:6.84rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004629-24.png);
display:flex;
align-items:center;
font-size:0.29rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
text-align:center;

}
}.ar-SA{
.u_c_INJH138.normal{
position:absolute;
width:1.80rem;
height:1.04rem;
top:0.41rem;
right:0.73rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721299004688-18.png);
background-size:contain;

}
}.ar-SA{
.u_c_5DOV139.normal{
position:absolute;
width:9.48rem;
height:1.89rem;
background:no-repeat center;
background-size:contain;
top:4.63rem;
left:0.19rem;
font-size:1.07rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;
text-shadow:0 0 20px black;

}
}.ar-SA{
.u_c_G5KT140.normal{
position:relative;
width:9.24rem;
height:0.49rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16709834565925.png);
margin:auto;
margin-top:7.33rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.0;
font-size:0.29rem;
color:#ffffff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ar-SA{
.u_c_7OVW141.normal{
position:relative;

}
}.ar-SA{
.u_c_8QKA142.normal{
position:relative;
margin:auto;
margin-top:0.53rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_8QKA142.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_8QKA142.normal .txt{
font-size:0.29rem;
color:#ffffff;

}

.u_c_8QKA142.normal .btn{
margin:auto 0.13rem;

}
}.ar-SA{
.u_c_IJFI143.normal{
position:relative;

}
}.ar-SA{
.u_c_5076144.normal{
position:relative;

}
}.ar-SA{
.u_c_9N0F146.normal{
position:relative;

}
}.ar-SA{
.u_c_IC6I148.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ar-SA{
.u_c_67TS149.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_31I8151.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_8RVR152.normal{
position:relative;

}
}.ar-SA{
.u_c_IJTU154.normal{
position:relative;

}
}.ar-SA{
.u_c_HF2S156.normal{
position:relative;

}
}.ar-SA{
.u_c_B3AX158.normal{
position:relative;

}
}
</style>
